<nav class="menu-area">
    <ul class="primary-menu container">
        <li><a  routerLinkActive="active"  routerLink="/como-tratamos-seus-dados">Como tratamos seus dados</a></li>
        <li><a  routerLinkActive="active"  routerLink="/entenda-as-finalidades-de-uso">Entenda as finalidades de uso</a></li>
        <li><a  routerLinkActive="active"  routerLink="/conheca-seus-direitos">Conheça seus direitos</a></li>
        <li><a  routerLinkActive="active"  routerLink="/como-protegemos-seus-dados">Como protegemos seus dados</a></li>
    </ul>
</nav>